import { ReactNode } from 'react';
import { CodeType } from '../CodeType';
import { BuildCodeParams, CodeSample } from './CodeSample';
import Paragraph from 'antd/lib/typography/Paragraph';
import Text from 'antd/lib/typography/Text';
import CodeBlock from '../CodeBlock';

/* eslint-disable no-useless-escape */
export default class MobileIosSample extends CodeSample {
  name = 'iOS';
  language = 'swift';
  codeType = CodeType.MOBILE;
  tabIcon = '';
  commentChar = undefined;

  buildCode({ environment, notification, user }: BuildCodeParams): ReactNode {
    const code = `class AppDelegate: NotificationApiAppDelegate {
    func application(_ application: UIApplication, didFinishLaunchingWithOptions launchOptions: [UIApplication.LaunchOptionsKey : Any]? = nil) -> Bool {
        NotificationApi.shared.configure(withCredentials: NotificationApiCredentials(clientId: "${environment?.clientId}", userId: "${user.email}"))
        
        NotificationApi.shared.requestAuthorization { granted, _ in
            print("Is authorized?: \(granted)")
        }        

        return true
    }
}`;

    return (
      <>
        <Paragraph style={{ paddingTop: 10 }}>
          Enable APNs credentials (see{' '}
          <a href="https://docs.notificationapi.com/guides/mobile-push#apple-push-notifications-service-apns">
            our guide here
          </a>
          ) for your project.
        </Paragraph>
        <Paragraph>
          Then add{' '}
          <Text code>
            https://github.com/notificationapi-com/notificationapi-ios-sdk.git
          </Text>{' '}
          as a dependency to your project (see{' '}
          <a href="https://developer.apple.com/documentation/xcode/adding-package-dependencies-to-your-app">
            Apple's guide to installing package dependencies
          </a>
          ).
        </Paragraph>
        <CodeBlock language={this.language} code={code} />
      </>
    );
  }
}
/* eslint-enable no-useless-escape */
